<template>
  <v-dialog persistent v-model="value" max-width="1300px" scrollable>
    <v-card>
      <v-card-title class="headline gradiente lighten-2 elevation-3">
        <span class="white--text">Crear Comunicado</span>
      </v-card-title>
      <v-card-text style="max-height: 700px;">
        <v-layout wrap>
          <v-flex xs12>
            <v-stepper v-model="e1" class="elevation-0">
              <v-stepper-header>
                <v-stepper-step :complete="e1 > 1" :step="1">Tipo</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step :complete="e1 > 2" :step="2">Datos generales</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step v-if="noticeForm.type == 'E'" :complete="e1 > 3" :step="3">Lugar</v-stepper-step>

                <v-divider v-if="noticeForm.type == 'E'"></v-divider>

                <v-stepper-step
                  :complete="e1 > (noticeForm.type == 'E' ? 4 : 3)"
                  :step="(noticeForm.type == 'E' ? 4 : 3)"
                >Agrega una imagen</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                  :complete="e1 > (noticeForm.type == 'E' ? 5 : 4)"
                  :step="(noticeForm.type == 'E' ? 5 : 4)"
                >Agrega un documento o video</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                  :complete="e1 > (noticeForm.type == 'E' ? 6 : 5)"
                  :step="(noticeForm.type == 'E' ? 6 : 5)"
                >Notificados</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step
                  :step="(noticeForm.type == 'E' ? 7 : 6)"
                >Completado</v-stepper-step>
              </v-stepper-header>

              <v-stepper-items>
                
                <v-stepper-content :step="1">
                  <v-layout row wrap justify-center>
                    <v-flex xs12>
                      <Type v-model="noticeForm.type" :v="$v.noticeForm"></Type>
                    </v-flex>
                  </v-layout>
                </v-stepper-content>

                <v-stepper-content :step="2">
                  <NoticeData v-model="noticeForm" :v="$v.noticeForm"></NoticeData>
                </v-stepper-content>

                <v-stepper-content v-if="noticeForm.type == 'E'" :step="3">
                  <PlaceNotice v-model="$v.noticeForm.place.$model"></PlaceNotice>
                </v-stepper-content>

                <v-stepper-content
                  :step="(noticeForm.type == 'E' ? 4 : 3)"
                >
                  <NoticeImage v-model="noticeForm.imgs"></NoticeImage>
                </v-stepper-content>

                <v-stepper-content
                  :step="(noticeForm.type == 'E' ? 5 : 4)"
                >
                  <NoticePDF
                    :notice="noticeForm"
                  ></NoticePDF>
                </v-stepper-content>

                <v-stepper-content
                  :step="(noticeForm.type == 'E' ? 6 : 5)"
                >
                  <NoticeBroadcast
                    :cancel="flags.cancel"
                    @selected="selectionAudiency"
                  />
                </v-stepper-content>

                <v-stepper-content
                  :step="(noticeForm.type == 'E' ? 7 : 6)"
                >
                  <detailNotice :notice="noticeForm" :v="$v.noticeForm"></detailNotice>
                </v-stepper-content>

              </v-stepper-items>
              <alert v-model="toast.alert" title="Aviso" :description="toast.description"></alert>
            </v-stepper>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="disabled" :disabled="e1 == 1" color="primary" @click="back" icon>
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" @click="close" flat>Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="disabled" color="primary" @click="next" icon>
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import Type from "../Sections/Notices/Type";
import data from "../Sections/Notices/Data";
import EventDates from "../Sections/Notices/EventDates";
import NoticeImage from "../Sections/Notices/NoticeImage";
import NoticeBroadcast from "../Tools/AudiencePayment.vue";
import alert from "../Dialogs/Alert";
import detailNotice from "../Sections/Notices/Details";
import PlaceNotice from "../Sections/Notices/PlaceNotice";
import NoticePDF from "../Sections/Notices/NoticePDF";
export default {
  components: {
    Type,
    NoticeData: data,
    EventDates,
    NoticeImage,
    NoticeBroadcast,
    alert,
    detailNotice,
    PlaceNotice,
    NoticePDF
  },
  validations: {
    noticeForm: {
      type: { required },
      title: { required },
      description: { required },
      startDate: { required },
      endDate: {
        validateDateEnd() {
          if (this.noticeForm.endDate) {
            return this.noticeForm.startDate < this.noticeForm.endDate
              ? true
              : false;
          }
          return true;
        }
      },
      place: { required },
      confirmParent: {},
      assistanceRequired: {}
    }
  },
  props: ["value"],
  watch: {
    value() {
      if (this.value && this.flags.cancel) {
        this.flags.cancel = false;
      }
    }
  },
  data: () => ({
    e1: 0,
    noticeForm: {
      type: "A",
      title: "",
      description: "",
      startDate: "",
      endDate: "",
      levels: [],
      students: [],
      groups: [],
      institutional: false,
      place: "",
      confirmParent: false,
      assistanceRequired: false,
      files: []
    },
    toast: {
      alert: false,
      description: ""
    },
    flags: {
      cancel: false
    },
    typeBroadcast: "",
    disabled: true
  }),
  methods: {
    close() {
      this.noticeForm = {
        type: "A",
        title: "",
        description: "",
        startDate: "",
        endDate: "",
        levels: [],
        students: [],
        groups: [],
        place: "",
        confirmParent: false,
        assistanceRequired: false,
        img: "",
        files: []
      };
      this.disabled = true;

      this.flags.cancel = true;
      this.e1 = 1;
      this.$v.noticeForm.$reset();
      this.$emit("input", false);
    },
    next() {
      switch (this.e1) {
        case 1:
          if (this.noticeForm.type == "E") {
            this.$v.noticeForm.startDate.$touch();
            this.$v.noticeForm.endDate.$touch();
            if (!this.$v.noticeForm.startDate.$invalid && !this.$v.noticeForm.endDate.$invalid) {
              this.e1++;
            }
          } else {
            this.e1++;
          }
          break;
        case 2:
          this.$v.noticeForm.title.$touch();
          this.$v.noticeForm.description.$touch();
          if (!this.$v.noticeForm.title.$invalid && !this.$v.noticeForm.description.$invalid) {
            this.e1++;
          }
          break;
        case 3:
          if (this.noticeForm.type == "E") {
            // place
            this.$v.noticeForm.place.$touch();
            if (!this.$v.noticeForm.place.$invalid) {
              this.e1++;
            } else {
              this.toast.description = "Debes de proporcionar una dirección o sitio válido";
              this.toast.alert = true;
            }
          } else {
            // image
            this.e1++;
          }
          break;
        case 4:
          this.e1++;
          break;
        case 5:
          switch (this.noticeForm.type) {
            case "E":
              // attachment
              this.e1++;
              break;
            default:
              // audience
              if (this.noticeForm.students.length > 0 || this.noticeForm.groups.length > 0 || this.noticeForm.levels.length > 0 || this.noticeForm.institutional) {
                this.e1++;
              } else {
                this.toast.description = "Debes agregar ya sea la institución o al menos un nivel, grupo o estudiante";
                this.toast.alert = true;
              }
              break;
          }
          break;
        case 6:
          switch (this.noticeForm.type) {
            case "E":
              if (this.noticeForm.students.length > 0 || this.noticeForm.groups.length > 0 || this.noticeForm.levels.length > 0 || this.noticeForm.institutional) {
                  this.e1++;
              } else {
                this.toast.description = "Debes agregar ya sea la institución o al menos un nivel, grupo o estudiante";
                this.toast.alert = true;
              }
              break;
            default:
              this.createNotice();
              break;
          }
          break;
        case 7:
          this.createNotice();
          break;
      }
    },
    back() {
      this.e1--;
    },
    selectionAudiency(event) {
      this.noticeForm.levels = event.levels;
      this.noticeForm.groups = event.ggs;
      this.noticeForm.students = event.students;
      this.noticeForm.institutional = event.institutional
      this.typeBroadcast = event.type;
    },
    createNotice() {
      this.disabled = false;
      this.$emit("loading");
      var notice = {
        type: this.noticeForm.type,
        title: this.noticeForm.title,
        description: this.noticeForm.description,
        startDate: this.noticeForm.startDate,
        endDate: this.noticeForm.endDate,
        levels: this.noticeForm.levels,
        students: this.noticeForm.students,
        groups: this.noticeForm.groups,
        place: this.noticeForm.place,
        confirmParent: this.noticeForm.confirmParent,
        assistanceRequired: this.noticeForm.assistanceRequired,
        imgs: this.noticeForm.imgs,
        files: this.noticeForm.files,
        branch: {
          id: this.$store.getters.getBranch.id
        }
      };
      this.$store
        .dispatch("notice/createNotice", notice)
        .then(response => {
          this.$emit("success");
          this.disabled = true;
          this.close();
        })
        .catch(error => {
          this.disabled = true;
          this.$emit("failed");
          console.log(error);
        });
    }
  }
};
</script>

<style>
</style>
